import React from 'react';
import PropTypes from 'prop-types';
import VirtualizedVSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

const VSelect = (props) => {
	const {list, value, onChange, matchProp, disabled, clearable, searchable, simpleValue, multi, ...rest} = props;

	return (
		<VirtualizedVSelect
			options={list}
			value={value}
			onChange={onChange}
			matchProp={matchProp}
			disabled={disabled}
			clearable={clearable}
			searchable={searchable}
			simpleValue={simpleValue}
			multi={multi}
			{...rest}
		/>
	);
};

VSelect.defaultProps = {
	matchProp: 'label',
	disabled: false,
	clearable: false,
	searchable: true,
	simpleValue: true,
	multi: false
};

VSelect.propTypes = {
	list: PropTypes.array.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onChange: PropTypes.func.isRequired,
	matchProp: PropTypes.string,
	disabled: PropTypes.bool,
	clearable: PropTypes.bool,
	searchable: PropTypes.bool,
	multi: PropTypes.bool
};

export default VSelect;